export const formatQuantity = (quantity?: number | null | string): string => {
  if (quantity == null || quantity === '') return "0";
  const num = typeof quantity === 'string' ? parseFloat(quantity) : quantity;
  if (isNaN(num)) return "0";
  
  return new Intl.NumberFormat('tr-TR', {
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(num);
};

export const formatCapacity = (usedMB: number, totalGB: number) => {
  // Eğer totalGB tanımlanmamış veya 0 ise hata oluşmaması için direkt 0 dönelim
  if (!totalGB || totalGB <= 0) {
    return {
      displayText: `${(usedMB / 1024).toFixed(2)} GB / 0 GB`,
      percentage: "0.0",
      percentageValue: 0,
      isFull: usedMB > 0 // Kapasite 0 ama veri varsa dolu sayılır
    };
  }

  const usedGB = (usedMB / 1024).toFixed(2);
  const numericPercentage = Math.min(((usedMB / (totalGB * 1024)) * 100), 100);
  
  return {
    displayText: `${usedGB} GB / ${totalGB.toFixed(2)} GB`,
    percentage: numericPercentage.toFixed(1),
    percentageValue: numericPercentage,
    isFull: (usedMB / 1024) >= totalGB
  };
};